import * as React from 'react';
import { StyledHTMLElement } from 'styletron-react';
import { styled } from 'styletron-react';

export const TitleSubStyle: React.CSSProperties = {
    fontFamily: 'Segoe UI',
    fontSize: '1.2rem',
    fontWeight: 100,
    color: 'rgba(0,0,0,0.6)'
};

export const TitleSub = styled('h2', TitleSubStyle);



// WEBPACK FOOTER //
// ./primitives/TitleSub.tsx